var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateVoucher2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.625 7.875 10.5m0 0L9.75 8.625M7.875 10.5V6",
    stroke: "#545454",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1.19a1 1 0 0 1-.175.566l-.764 1.113a2 2 0 0 0 0 2.262l.764 1.113a1 1 0 0 1 .175.566V12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1.19a1 1 0 0 1 .175-.566l.764-1.113a2 2 0 0 0 0-2.262l-.764-1.113A1 1 0 0 1 2 5.19V4z",
    stroke: "#545454",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateVoucher2);
export default __webpack_public_path__ + "static/media/generateVoucher2.4fe42f3b9948c19505c8ddf5f6e566a3.svg";
export { ForwardRef as ReactComponent };